import * as z from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {LinkSchema} from './link'
import {LinkGroupSchema} from './linkGroup'

export const PrimerComponentSubnavSchema = buildEntrySchemaFor('primerComponentSubnav', {
  fields: z.lazy(() =>
    z.object({
      cta: LinkSchema.optional(),
      heading: LinkSchema,
      subheading: LinkSchema.optional(),
      links: z.array(LinkSchema.or(LinkGroupSchema)),
    }),
  ),
})

export type PrimerComponentSubnav = z.infer<typeof PrimerComponentSubnavSchema>
